import axios from "../api/axios";
import { createApi } from "@reduxjs/toolkit/query/react";

const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: "" }) =>
    async ({ url, method, data, params, headers }) => {
        // console.log(baseUrl + url, method, data, params, headers);
        try {
            const result = await axios({
                url: baseUrl + url,
                method,
                data,
                params,
                headers,
            });
            // console.log(result)
            return {
                status: result.status,
                data: result.data,
            };
        } catch (axiosError) {
            const err = axiosError;
            // console.log(err);
            // return {
            //     error: {
            //         status: err.response?.status,
            //         data: err.response?.data || err.message,
            //     },
            // };

            // console.log("## err ");
            // console.log(err);
            return {
                status: err.response?.status,
                error: err.response?.data?.error || err.message,
                message: err.response?.status === 417 ? err.response?.data?.message : "오류가 발생하였습니다. 다시 시도하여주세요.",
            };
        }
    };

export const apiSlice = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: process.env.REACT_APP_SERVER_URL,
    }),
    endpoints: (build) => ({}),
});
